var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_203_12991)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 32,
    height: 32,
    rx: 7.27273,
    fill: "#EE9736"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_12991)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_203_12991",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.147 17.6498C16.147 17.2892 15.8988 17.0176 15.5699 17.0176H11.2554C10.9256 17.0176 10.6777 17.2892 10.6777 17.6498C10.6777 18.0008 10.9289 18.2661 11.263 18.2661H12.7616V23.1242C12.7616 23.4785 13.0306 23.7237 13.4154 23.7237C13.8016 23.7237 14.0716 23.4785 14.0716 23.1242V18.2661H15.5702C15.8934 18.2661 16.147 17.9953 16.147 17.6498Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.147 17.6498C16.147 17.2892 15.8988 17.0176 15.5699 17.0176H11.2554C10.9256 17.0176 10.6777 17.2892 10.6777 17.6498C10.6777 18.0008 10.9289 18.2661 11.263 18.2661H12.7616V23.1242C12.7616 23.4785 13.0306 23.7237 13.4154 23.7237C13.8016 23.7237 14.0716 23.4785 14.0716 23.1242V18.2661H15.5702C15.8934 18.2661 16.147 17.9953 16.147 17.6498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7616 18.2661H13.4889V17.5389H12.7616V18.2661ZM14.0716 18.2661V17.5389H13.3443V18.2661H14.0716ZM16.8743 17.6498C16.8743 16.9512 16.3613 16.2903 15.5699 16.2903V17.7449C15.5507 17.7449 15.5266 17.7406 15.5019 17.7295C15.4776 17.7187 15.4584 17.7038 15.4447 17.6889C15.4165 17.658 15.4197 17.6372 15.4197 17.6498H16.8743ZM15.5699 16.2903H11.2554V17.7449H15.5699V16.2903ZM11.2554 16.2903C10.4634 16.2903 9.95046 16.951 9.95046 17.6498H11.405C11.405 17.637 11.4083 17.6579 11.3799 17.6889C11.3661 17.704 11.3469 17.7188 11.3227 17.7297C11.298 17.7407 11.2741 17.7449 11.2554 17.7449V16.2903ZM9.95046 17.6498C9.95046 18.3658 10.4916 18.9934 11.263 18.9934V17.5389C11.2962 17.5389 11.3404 17.555 11.3727 17.589C11.3871 17.6042 11.3957 17.6194 11.4003 17.6314C11.405 17.6435 11.405 17.6504 11.405 17.6498H9.95046ZM11.263 18.9934H12.7616V17.5389H11.263V18.9934ZM12.0344 18.2661V23.1242H13.4889V18.2661H12.0344ZM12.0344 23.1242C12.0344 23.4951 12.1799 23.8431 12.4531 24.0932C12.7215 24.3389 13.0686 24.4509 13.4154 24.4509V22.9964C13.3774 22.9964 13.3976 22.9859 13.4353 23.0204C13.4531 23.0367 13.4682 23.0578 13.4781 23.0807C13.4878 23.1035 13.4889 23.1198 13.4889 23.1242H12.0344ZM13.4154 24.4509C13.7622 24.4509 14.1095 24.3393 14.3783 24.0942C14.6523 23.8443 14.7988 23.4961 14.7988 23.1242H13.3443C13.3443 23.1194 13.3454 23.1027 13.3553 23.0797C13.3653 23.0566 13.3805 23.0356 13.3982 23.0194C13.4355 22.9854 13.4548 22.9964 13.4154 22.9964V24.4509ZM14.7988 23.1242V18.2661H13.3443V23.1242H14.7988ZM14.0716 18.9934H15.5702V17.5389H14.0716V18.9934ZM15.5702 18.9934C16.3396 18.9934 16.8743 18.351 16.8743 17.6498H15.4197C15.4197 17.6428 15.4232 17.6179 15.4488 17.5905C15.4758 17.5617 15.5209 17.5389 15.5702 17.5389V18.9934Z",
    fill: "white",
    mask: "url(#path-2-inside-1_203_12991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7406 16.9004C16.9057 16.9004 15.7188 18.2523 15.7188 20.3436C15.7188 22.4449 16.9046 23.8028 18.7406 23.8028C20.5665 23.8028 21.746 22.4482 21.746 20.3526C21.746 18.255 20.5676 16.9004 18.7406 16.9004ZM18.7406 22.5628C17.7001 22.5628 17.054 21.7162 17.054 20.3526C17.054 18.9835 17.7001 18.132 18.7406 18.132C19.7715 18.132 20.4116 18.9655 20.4116 20.3046C20.4124 21.7397 19.8028 22.5628 18.7406 22.5628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1089 17.0176H23.37C22.6557 17.0176 22.293 17.3959 22.293 18.1426V23.1081C22.293 23.4769 22.5534 23.7239 22.9407 23.7239C23.3209 23.7239 23.5873 23.4741 23.5873 23.1163V21.1783H25.0786C26.484 21.1783 27.3234 20.3809 27.3234 19.0434C27.3234 17.7758 26.4954 17.0176 25.1089 17.0176ZM25.9974 19.0595C25.9974 19.6674 25.6917 19.963 25.0614 19.963H23.5871V18.2416H25.0614C25.6917 18.2419 25.9974 18.5091 25.9974 19.0595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5886 15.3295V12.5188H21.376C21.8388 12.5188 22.2195 12.0756 22.2648 11.5075L18.7213 7.43164L15.2012 11.5059C15.247 12.074 15.6272 12.5185 16.0905 12.5185H16.8779V15.3293L20.5886 15.3295Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_12991",
    x: 0.0909092,
    y: 0,
    width: 37.8182,
    height: 37.8182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.90909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45455
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_12991"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_12991",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_12991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4545,
    height: 17.4545,
    fill: "white",
    transform: "translate(10.2729 7.27295)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTop);
export default __webpack_public_path__ + "static/media/scroll-top.6721c60b35477dda98ceb54934fe9e1f.svg";
export { ForwardRef as ReactComponent };